module.exports = __webpack_public_path__ + "img/footer-corp.44781693.png";